module.exports = __webpack_public_path__ + "img/jqxx32.b177aa5f.svg";